import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import typeScript from '../assets/ts.png';
import git from '../assets/git.png';
import react from '../assets/react.png';
import sass from '../assets/sass.png';
import laravel from '../assets/laravel.png';
import about01 from '../assets/about01.png';
import about02 from '../assets/about02.png';
import about03 from '../assets/about03.png';
import about04 from '../assets/about04.png';
import profile from '../assets/profile.png';
import circle from '../assets/circle.svg';
import logo from '../assets/motiur.png';
import nb from '../assets/nb.png';
import skype from '../assets/skype.png';
import spotify from '../assets/spotify.png';

export default {
    email,
    mobile,
    typeScript,
    git,
    react,
    sass,
    about01,
    about02,
    about03,
    about04,
    profile,
    circle,
    logo,
    nb,
    skype,
    spotify,
    laravel,
};